'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$Person$1(name, password, birthDate, fav, pet, email, age, size) {
  this.sO = null;
  this.sP = null;
  this.sL = null;
  this.sN = null;
  this.sQ = null;
  this.sM = null;
  this.sK = null;
  this.sR = 0.0;
  this.sO = name;
  this.sP = password;
  this.sL = birthDate;
  this.sN = fav;
  this.sQ = pet;
  this.sM = email;
  this.sK = age;
  this.sR = size;
}
export { $c_Lsamples_Persons$package$Person$1 as $c_Lsamples_Persons$package$Person$1 };
$p = $c_Lsamples_Persons$package$Person$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$Person$1;
/** @constructor */
function $h_Lsamples_Persons$package$Person$1() {
}
export { $h_Lsamples_Persons$package$Person$1 as $h_Lsamples_Persons$package$Person$1 };
$h_Lsamples_Persons$package$Person$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (-1907849355));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sO));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sP));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sL));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sN));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sQ));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sM));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sK));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().qW(this.sR));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 8);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_Persons$package$Person$1)) {
    if (((this.sO === x$0.sO) && (this.sP === x$0.sP))) {
      var x = this.sL;
      var x$2 = x$0.sL;
      var $x_5 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$3 = this.sN;
      var x$4 = x$0.sN;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.sQ;
      var x$6 = x$0.sQ;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.sM;
      var x$8 = x$0.sM;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.sK;
      var x$10 = x$0.sK;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.sR === x$0.sR);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 8;
});
$p.o = (function() {
  return "Person";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.sO;
      break;
    }
    case 1: {
      return this.sP;
      break;
    }
    case 2: {
      return this.sL;
      break;
    }
    case 3: {
      return this.sN;
      break;
    }
    case 4: {
      return this.sQ;
      break;
    }
    case 5: {
      return this.sM;
      break;
    }
    case 6: {
      return this.sK;
      break;
    }
    case 7: {
      return this.sR;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_Persons$package$Person$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.el)));
}
export { $isArrayOf_Lsamples_Persons$package$Person$1 as $isArrayOf_Lsamples_Persons$package$Person$1 };
var $d_Lsamples_Persons$package$Person$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$Person$1, "samples.Persons$package$Person$1", ({
  el: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Persons$package$Person$1 as $d_Lsamples_Persons$package$Person$1 };
